{
  "platform": "Plataforma",
  "partner": "Partner",
  "tenants": "Inquilinos",
  "customers": "Clientes",
  "partners": "Partners",
  "enquiries": "Consultas",
  "teamAccess": "Equipo y acceso",
  "tenant": "Inquilino",
  "yourTenants": "Tus inquilinos",
  "noTenantAssignments": "Aún no hay asignaciones de inquilino.",
  "noPartnerCustomersYet": "Este socio aún no tiene clientes.",
  "onboarding": "Incorporación",
  "overview": "Resumen",
  "users": "Usuarios",
  "groups": "Grupos",
  "designer": "Diseñador",
  "rules": "Reglas",
  "campaigns": "Campañas",
  "tester": "Probador"
}
